import { lazy } from 'react';

export const AnalyticsAsync = lazy(() => import('./analytics.component'));
